import React from "react";
import Banner from "../../../library/Banner";
import PhaseCard from "./PhaseCard";
import { StyledEmptyMessage, StyledLoadingRow, StyledPhaseColumn } from "./studyPaths.styles";

/**
 * Left column of the Study Phases list (SPEC1) — one `PhaseCard` per phase.
 */
function PhaseCardsColumn({ phases = [], loading = false, error = false, selectedPhaseId, onSelect, onEdit, onDelete, editDisabled = false, editDisabledReason, deleteDisabled = false, deleteDisabledReason }) {
    if (loading) {
        return (
            <StyledLoadingRow>Loading phases...</StyledLoadingRow>
        );
    }

    if (error) {
        return (
            <Banner tone="warning">
                The phase list couldn't be loaded. Reload to try again.
            </Banner>
        );
    }

    if (phases.length === 0) {
        return (
            <StyledEmptyMessage>No phases have been created for this version yet.</StyledEmptyMessage>
        );
    }

    return (
        <StyledPhaseColumn>
            {phases.map((phase) => (
                <PhaseCard
                    key={phase.id}
                    phase={phase}
                    selected={phase.id === selectedPhaseId}
                    onSelect={onSelect}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    editDisabled={editDisabled}
                    editDisabledReason={editDisabledReason}
                    deleteDisabled={deleteDisabled}
                    deleteDisabledReason={deleteDisabledReason}
                />
            ))}
        </StyledPhaseColumn>
    );
}

PhaseCardsColumn.displayName = "PhaseCardsColumn";

export default PhaseCardsColumn;
